import { orderingDiagnostics as genericOrderingDiagnostics } from 'modules/agreement/discountTree';
import { contexts, type DiscountContext, type ProviderAgreementDiscountRule } from './types';
import type { PolicyOrderingDiagnostic } from 'modules/agreement/factorPolicy/ordering';

export type ProviderOrderingDiagnostic = {
  earlierRuleId: number;
  contexts: readonly DiscountContext[];
};

/** Authoring feedback for exact-endpoint siblings; this never blocks a mutation. */
export function orderingDiagnostics(
  rules: readonly ProviderAgreementDiscountRule[],
): ReadonlyMap<number, readonly ProviderOrderingDiagnostic[]> {
  return genericOrderingDiagnostics(
    rules,
    contexts,
    (rule) => [rule.target_activity?.id ?? null, rule.target_category?.id ?? null],
    (rule, context) => {
      const value = rule[context];
      return value != null;
    },
  ) as ReadonlyMap<number, readonly ProviderOrderingDiagnostic[]>;
}

export function policyOrderingDiagnostics(
  rules: readonly ProviderAgreementDiscountRule[],
): ReadonlyMap<number, readonly PolicyOrderingDiagnostic[]> {
  return genericOrderingDiagnostics(
    rules,
    ['Provider'] as const,
    (rule) => [rule.target_activity?.id ?? null, rule.target_category?.id ?? null],
    (rule) => rule.factor_policy !== null,
  );
}
